import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

export function useUniqueSelector() {
  // CSS id's must start with a letter
  return useMemo(() => `id-${uuidv4()}`, []);
}
